<template>
  <div class="create-complete-wrapper">
    <div>
      <div style="flex:1;" class="pr-2">
        <h5 style="color: #101010;">
          {{ $l('tips_custCreateComplete_1') || '客户档案填写完成' }}
        </h5>
        <p style="font-size:14px;color: #6C6C6C;" class="m-0 text-truncate">
          {{
            $l('tips_custCreateComplete_2') ||
              '该客户已作为海选客户登记进入系统，接待人员可以在我的客户中查看。'
          }}
        </p>
      </div>
      <div class="create-complete-result">
        <div class="create-complete-icon"></div>
        <div style="flex: 1;" class="pl-2">
          <h6 style="color: #101010;">
            {{ $l('tips_custCreateComplete_3') || '客户档案需要提交审核！' }}
          </h6>
          <h6 style="color: #6C6C6C;" class="m-0">
            {{
              $l('tips_custCreateComplete_4') ||
                '审核通过后，该客户将转为潜在客户，可以进行业务跟进，'
            }}
            <span class="submit-btn" @click="submit()">
              {{ $l('tips_custCreateComplete_submit') || '立即提交审核' }}
            </span>
          </h6>
        </div>
      </div>
      <div class="mt-4 d-flex justify-content-end">
        <el-button plain size="small" @click="$emit('close')">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  methods: {
    async submit() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_formal_customer') || '是否提交转正式客户申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerConvertFormalApi({ custCode: this.custCode })
        .catch(() => false)
      this.loadingClose()
      this.$emit('reload')
      this.$emit('close')
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.create-complete-wrapper {
  display: flex;
  justify-content: center;
  padding: 80px 0;
  .create-complete-result {
    display: flex;
    align-items: center;
    margin-top: 20px;
    border: 1px dashed #e99d42;
    background-color: #fff8dd;
    border-radius: 5px;
    padding: 20px 25px;

    .submit-btn {
      color: #007bff;
      cursor: pointer;
    }
    .create-complete-icon {
      width: 60px;
      height: 60px;
      min-width: 60px;
      background-image: url('../../new_releases.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}
</style>
